const {KitModule, registerModule} = window;

class Multicard extends KitModule {
  constructor($element) {
    super($element);
    this.mount();
  }

  mount() {
    this.preventBlur();
    this.bindSetttings();
    this.bindObserver();
    this.bindEvents();
  }

  // https://stackoverflow.com/questions/72404034/chrome-shows-lottie-animation-blurry
  preventBlur() {
    this.spacer = document.querySelector('.lottie-spacer');
    this.spacer.addEventListener('play', (event) => {
      event.target.shadowRoot.querySelector('svg').style.transform = '';
    });
  }

  bindSetttings() {
    this.observer = null;
    this.options = {
      rootMargin: '0px',
      threshold: 0,
    };
  }

  bindEvents() {
    this.$card.forEach((card) => {
      card.addEventListener('mouseover', this);
      card.addEventListener('mouseleave', this);
    });
  }

  onmouseover(e) {
    const target = e.currentTarget;
    const card = target.querySelector('.lottie');
    if (card) {
      card.setLooping(true);
      card.setDirection(1);
      card.play();
    }
  }

  onmouseleave(e) {
    const target = e.currentTarget;
    const card = target.querySelector('.lottie');
    if (card) {
      card.setLooping(false);
      // card.pause();
      card.setDirection(-1);
      card.play();
    }
  }

  bindObserver() {
    this.observer = new IntersectionObserver(this.observerCallback, this.options);
    this.observer.observe(this.$element);
  }

  observerCallback(entries) {
    entries.forEach((entry) => {
      const cards = [...entry.target.querySelectorAll('.lottie')];
      cards.forEach((card) => {
        card.setLooping(false);
        if (entry.isIntersecting) {
          card.play();
        } else {
          card.pause();
        }
      });
    });
  }
}

registerModule('Multicard', Multicard);
